module.exports = __webpack_public_path__ + "static/media/Compra-segura.1fb2c032.svg";